<template>
  <div class="quick-filter">
    <b-button
      class="left-button"
      :type="computeType('MY_ASSIGNMENTS')"
      rounded
      @click="change('MY_ASSIGNMENTS')"
      >{{ $t("quick-filter.assigne-a-moi") }}
    </b-button>
    <b-button
      v-if="showUnassigned"
      class="middle-button"
      :type="computeType('NOT_ASSIGNED')"
      rounded
      @click="change('NOT_ASSIGNED')"
      >{{ $t("quick-filter.non-assigne") }}
    </b-button>
    <b-button
      :class="{ 'middle-button': !showUnassigned, 'right-button': showUnassigned }"
      :type="computeType(undefined)"
      rounded
      @click="change(undefined)"
      >{{ $t("quick-filter.tous-les-projets") }}
    </b-button>
  </div>
</template>

<script lang="ts">
import { QuickFilter } from "@/model/bean/GeneratedDTOs"
import { defineComponent, PropType } from "vue"
import { BButton } from "buefy"

export default defineComponent({
  name: "QuickFilterView",
  components: {
    BButton,
  },
  props: {
    quickFilter: {
      type: String as PropType<QuickFilter | undefined>,
      default: undefined,
    },
    showUnassigned: {
      type: Boolean,
    },
  },

  emits: ["quick-filter-changed"],
  methods: {
    change(quickFilter: QuickFilter | undefined): void {
      this.$emit("quick-filter-changed", quickFilter)
    },

    computeType(value: QuickFilter | undefined): string {
      return this.quickFilter === value ? "is-link" : ""
    },
  },
})
</script>

<style lang="scss">
.quick-filter {
  display: flex;
  justify-content: center;

  .left-button {
    padding-right: 40px !important;
    z-index: 1;
  }

  .middle-button {
    left: -30px;
    z-index: 2;
  }

  .right-button {
    left: -65px;
    padding-left: 40px !important;
    z-index: 1;
  }
}
</style>
